/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'tools': {
    width: 16,
    height: 16,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M989.867 214.596L512 9.796l-477.867 204.8v583.885L512 1001.916l41.267-17.579h8.738v-3.72l427.862-182.102V214.596zM512 388.916l-121.105-51.542L731.102 180.36c.785-.376 1.297-1.059 2.048-1.502l135.714 58.163L512 388.915zm137.284-246L306.142 301.295l-151.006-64.307L512 84.07l137.284 58.846zM102.4 288.734l136.533 58.129v212.07a34.133 34.133 0 1068.267 0V375.98l.068-.034 186.47 79.394v464.623L102.4 753.357V288.734zm459.605 617.71V441.823L921.6 288.734V753.39L562.005 906.445z"/>'
  }
})
